import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

//locales
import en_US from './languages/en_US.json';
import fr_BE from './languages/fr_BE.json';
import nl_BE from './languages/nl_BE.json';
import {LanguageUtils} from '@bobex/react-core/utils/LanguageUtils';

const resources = {
  en_US: { translation: en_US },
  fr_BE: { translation: fr_BE },
  nl_BE: { translation: nl_BE },
};

i18n.use(initReactI18next).init({
  debug: false, // Temporarily enable debug mode
  resources,
  lng: LanguageUtils.getLocale() || 'en_US',
  fallbackLng: 'en_US',
  returnEmptyString: false,
  parseMissingKeyHandler: (key) => `*${key}*`,
  interpolation: {
    escapeValue: false,
  },
  defaultNS: 'translation',
  ns: ['translation'],
  react: {
    useSuspense: false, // This is important for SSR
  },
});

export default i18n;
